import moment from "moment";

// cohortType: 0 = normal (Duration/Rates/Remodel), 1 = Combination, 2 = Cohort
const COHORT_TYPE_LABELS = { 1: "Combination", 2: "Cohort" };

const getMostRecentPlanByStatus = (studyPlans, scenarioStatus) =>
  studyPlans
    .filter((sp) => sp.scenarioStatus === scenarioStatus)
    .sort((a, b) => new Date(b.simOptRunUpdateTs) - new Date(a.simOptRunUpdateTs))[0];

// Mirrors the backend precedence: most recent Baseline Plan, else most recent Ongoing Study
export const getApplicableActualsStudyPlan = (studyPlans = []) =>
  getMostRecentPlanByStatus(studyPlans, "Baseline Plan") ||
  getMostRecentPlanByStatus(studyPlans, "Ongoing Study");

// Business-readable message shown when Study Actuals/Remodel aren't available for the plan's type
export const getRemodelUnavailableMessage = (studyPlans = [], { hasActualsData = false } = {}) => {
  const plan = getApplicableActualsStudyPlan(studyPlans);
  const label = plan && COHORT_TYPE_LABELS[Number(plan.cohortType)];
  if (!label) return null;
  const subject = hasActualsData ? "Remodel is" : "Study Actuals and Remodel are";
  return `${subject} not available for '${label}' study plans. Remodel is only supported for Duration, Rates, or Remodel study plan types.`;
};

export const checkRemodelRun = (actualsData) => {
    if (actualsData.length > 0 && moment(actualsData[0].toolTips).isValid()) {
        return ((moment().diff(moment(actualsData[0].toolTips)) +
            new Date().getTimezoneOffset() * 60 * 1000) / 3600000 >= 24
        );
    }
    return true;
};